import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { languageswitchConstants } from '../constants';
import { SocialMediaListRender } from './SocialMediaListRender';


export const SocialMediaListNL = () => {
    const dispatch = useDispatch();
    const s = useSelector(state => state.socialmediaNL.socialmediaListNL);
    const [socialmediaListNL, setSocialmedialListNL] = useState(s);
    const loading = useSelector(state => state.socialmediaNL.loading);
    const e = useSelector(state => state.socialmediaNL.error);
    const [error, setError] = useState(e);
    const d = useSelector(state => state.socialmediaNL.done);
    const [done, setDone] = useState(d);
    var dataLimitPerPage = 15;

    const lang = useSelector(state => state.languageswitch);
    if (lang === languageswitchConstants.DUTCH_NR) {
        return <SocialMediaListRender
            stateList={s}
            socialmediaList={socialmediaListNL}
            setSocialmedialList={setSocialmedialListNL}
            loading={loading}
            errorState={e}
            error={error}
            setError={setError}
            doneState={d}
            done={done}
            setDone={setDone}
            dataLimitPerPage={dataLimitPerPage}
        />
    }
}